import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { PlantService } from '../_services';
import * as plantActions from '../_actions/plant';

@Injectable({
  providedIn: 'root',
})
export class PlantEffects {
  loadplants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(plantActions.loadPlants),
      mergeMap(() =>
        this.plantService.getPlants().pipe(
          map((plants) => plantActions.loadplantsSuccess({ plants })),
          catchError((error) => of(plantActions.loadplantsFailure({ error })))
        )
      )
    )
  );

  addplant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(plantActions.addplant),
      mergeMap(({ plant }) =>
        this.plantService.savePlant(plant).pipe(
          map((savedplant) => plantActions.addplantSuccess({ plant: savedplant })),
          catchError((error) => of(plantActions.addplantFailure({ error })))
        )
      )
    )
  );

  updateplant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(plantActions.updateplant),
      mergeMap(({ plant }) =>
        this.plantService.savePlant(plant).pipe(
          map((updatedplant) => plantActions.updateplantSuccess({ plant: updatedplant })),
          catchError((error) => of(plantActions.updateplantFailure({ error })))
        )
      )
    )
  );

  deleteplant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(plantActions.deleteplant),
      mergeMap(({ id }) =>
        this.plantService.deletePlant(id).pipe(
          map(() => plantActions.deleteplantSuccess({ id })),
          catchError((error) => of(plantActions.deleteplantFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private plantService: PlantService
  ) {}
}
